<h4 mat-dialog-title><mat-icon class="dialog-icon">credit_card</mat-icon><span class="span-title" i18n>Confirmation</span></h4>
<form  (ngSubmit)="onSubmit()"  id="frm">
    <div mat-dialog-content>
        <p i18n>Are you sure you want to withdraw this promotion?</p>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button color="primary" type="submit" cdkFocusInitial i18n>Confirm</button>
        <button mat-raised-button (click)="onNoClick()" [mat-dialog-close]="true" i18n>Cancel</button>
      </div>
</form>